import * as types from '../actions/actionTypes.js';

export default (state, action) => {
    switch (action.type) {

        case types.UI_TOGGLE_HEADER_MENU:
            return Object.assign({}, state, { drawerOpen: !state.drawerOpen });

        default:
            return state;
    }
};


export const getDrawerState = state => state.stolo.ui.header.drawerOpen;



// WEBPACK FOOTER //
// ./src/reducers/ui.header.js